import {
    INotificationItem,
    INotificationMessage,
    NotificationItemsListTransaction,
    NotificationMessagesListTransaction,
} from '../../../interfaces';
import { OperatorFunction } from 'rxjs';
import { scan } from 'rxjs/operators';

export const createNotificationItem = (isNew = true) => (message: INotificationMessage): INotificationItem => {
    return {
        ...message,
        haveBeenSeen: false,
        newMarkVisible: isNew,
    };
};

export function transformNotificationTransaction(transaction: NotificationMessagesListTransaction): NotificationItemsListTransaction {
    return {
        snapshot: transaction.snapshot?.map(createNotificationItem(false)),
        increment: transaction.increment?.map(createNotificationItem(true)),
    } as NotificationItemsListTransaction;
}

export function updateNotificationsAccumulator(
    acc: Array<INotificationItem>,
    changes: NotificationItemsListTransaction): Array<INotificationItem> {

    if (Boolean(changes.snapshot)) {
        return changes.snapshot;
    }

    if (Boolean(changes.increment)) {
        return [ ...changes.increment, ...acc ];
    }

    if (Boolean(changes.update)){
        // functions must not mutate external state.
        const result = [ ...acc ];

        changes.update.forEach(updateNotif => {
            const index = result.findIndex(accNotif => accNotif.id === updateNotif.id);
            if (index >= 0) {
                result[ index ] = updateNotif.action(result[ index ]);
            }
        });
        return result;
    }

    return acc;

}

export function collectNotificationsPool(): OperatorFunction<NotificationItemsListTransaction, Array<INotificationItem>> {
    return scan<NotificationItemsListTransaction, Array<INotificationItem>>(updateNotificationsAccumulator, []);
}
